import React from 'react';
import logoVaillant from 'images/vaillant.png';
import logoVaillant2x from 'images/vaillant@2x.png';
import logoVaillant3x from 'images/vaillant@3x.png';
import logoProtherm from 'images/protherm.png';
import logoProtherm2x from 'images/protherm@2x.png';
import logoProtherm3x from 'images/protherm@3x.png';

function Header(props) {
    let logo = null;
    if (props.brand === "protherm") {
    	const srcSet = `${logoProtherm} 1x, ${logoProtherm2x} 2x, ${logoProtherm3x} 3x`;
		logo = <img src={logoProtherm} srcSet={srcSet} alt="logo" className="logo"/>;
    } else if (props.brand === "vaillant") {
    	const srcSet = `${logoVaillant} 1x, ${logoVaillant2x} 2x, ${logoVaillant3x} 3x`;
		logo = <img src={logoVaillant} srcSet={srcSet} alt="logo" className="logo"/>;
    }
    return (
        <header className="header">
			{logo}
			{props.children}
		</header>
    );
}

Header.propTypes = {
	brand: React.PropTypes.string.isRequired
};
Header.defaultProps = {};
Header.contextTypes = {};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/